import { createFileRoute, notFound } from "@tanstack/react-router";
import { z } from "zod";
import { ModelDetailPage, type ModelTab } from "@/features/models/ModelDetailPage";
import { ApiError } from "@/lib/api/client";
import { modelDetailQuery } from "@/lib/api/queries";
import { DEFAULT_ENV, projectSearch } from "@/lib/search";

const search = projectSearch.extend({ tab: z.enum(["columns", "runs", "sql"]).optional() });

export const Route = createFileRoute("/w/$workspace/p/$project/models/$model")({
  validateSearch: search,
  loaderDeps: ({ search: s }) => ({ env: s.env ?? DEFAULT_ENV }),
  loader: async ({ context, params, deps }) => {
    try {
      return await context.queryClient.ensureQueryData(
        modelDetailQuery(params.workspace, params.project, params.model, deps.env),
      );
    } catch (e) {
      if (e instanceof ApiError && e.status === 404) throw notFound();
      throw e;
    }
  },
  component: () => {
    const { workspace, project, model } = Route.useParams();
    const s = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <ModelDetailPage
        workspace={workspace}
        project={project}
        model={model}
        env={s.env ?? DEFAULT_ENV}
        tab={(s.tab ?? "columns") as ModelTab}
        onTab={(tab) =>
          navigate({
            search: (prev) => ({ env: prev.env, tab: tab === "columns" ? undefined : tab }),
            replace: true,
          })
        }
      />
    );
  },
});
